<template>
  <label :class="classes">
    <input
      type="radio"
      :checked="shouldBeChecked"
      :value="value"
      @change="updateInput"
      :name="name"
    >
    <span></span>
    {{ label }}
  </label>
</template>
<script>
import classes from '@/utils/classes'

export default {
  name: 'Radio',
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    value: {
      type: String,
    },
    name: {
      type: String,
    },
    modelValue: {
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shouldBeChecked() {
      return this.modelValue === this.value
    },
    classes() {
      const { $style, theme, shouldBeChecked } = this
      return classes(
        $style.wrapper,
        shouldBeChecked && $style.checked,
        theme === 'green' && $style.green,
        theme === 'red' && $style.red,
      )
    },
  },
  methods: {
    updateInput() {
      const { disabled } = this

      if (!disabled) this.$emit('change', this.value)
    },
  },
}
</script>
<style lang="scss" module>
@import './Radio.scss';
</style>
